"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AddNewListButton = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("../../../../constants");
var _useTranslations = require("../../../../hooks/useTranslations");
var _constants2 = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const AddNewListButton = ()=>{
    const { translations } = (0, _useTranslations.useTranslations)();
    const { getTestId } = (0, _testidGenerator.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        href: "".concat(_constants.BASE_PATH, "/product-list/new"),
        "data-testid": getTestId(_constants2.ADD_NEW_LIST_BUTTON),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.IconButton, {
                variant: "contained",
                color: "primary",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.Add, {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                color: "textPrimary",
                fontWeight: "bold",
                textAlign: "left",
                children: translations.createAList
            })
        ]
    });
};
exports.AddNewListButton = AddNewListButton;
